module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('demo', {
    staticClass: "icon-demo",
    attrs: {
      "title": "Icon"
    }
  }, [_c('demo-item', {
    attrs: {
      "name": "default",
      "description": "默认",
      "code": _vm.size_code
    },
    slot: "left"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate)
      }
    }
  }, [_vm._v("Toast")])], 1), _vm._v(" "), _c('demo-item', {
    staticClass: "type-btn-group",
    attrs: {
      "name": "type",
      "description": "主题",
      "code": _vm.type_code
    },
    slot: "right"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'default')
      }
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'primary')
      }
    }
  }, [_vm._v("Primary")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'success')
      }
    }
  }, [_vm._v("Success")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'warning')
      }
    }
  }, [_vm._v("Warning")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, 'error')
      }
    }
  }, [_vm._v("Error")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "time",
      "description": "自动关闭的延时，单位毫秒",
      "code": _vm.time_code
    },
    slot: "left"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast('一秒后消失', {
          time: 1000
        })
      }
    }
  }, [_vm._v("延迟一秒")]), _vm._v(" "), _c('Btn', {
    on: {
      "click": _vm.control
    }
  }, [_vm._v("手动控制")])], 1), _vm._v(" "), _c('demo-item', {
    attrs: {
      "name": "callback",
      "description": "消失后的回调",
      "code": _vm.callback_code
    },
    slot: "right"
  }, [_c('Btn', {
    on: {
      "click": function($event) {
        _vm.$toast(_vm.nowDate, {
          callback: function () { return _vm.$toast('Callback！'); }
        })
      }
    }
  }, [_vm._v("回调函数")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-610a9703"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/demo/Toast.vue
// module id = 664
// module chunks = 0